module.exports = __webpack_public_path__ + "static/media/6.6e5e3385.svg";